import { BybList, BybSection } from "@Components/common/byb-ds";
import BybMetricCard from "@Components/common/byb-ds/cards/byb-metric-card";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import { MetricScores } from "@Helpers/types";
import useI18n from "@i18n";
import { Grid } from "@mui/material";

interface ISessionMetricsList {
  metricScores: MetricScores;
  compact?: boolean;
}

interface IMetricCardItem {
  id: string;
  metricType?: MetricFilterTypes;
  score?: number;
  target?: number;
}

const SKELETON_ITEMS_COUNT = 5;

const BybMetricsList = ({ metricScores, compact = false }: ISessionMetricsList) => {
  const { i18n } = useI18n();

  const metricItems: IMetricCardItem[] = metricScores
    ? Object.entries(metricScores).map(([metricType, values]) => ({
        id: metricType,
        metricType: metricType as MetricFilterTypes,
        score: values?.score ?? 0,
        target: values?.target,
      }))
    : Array.from({ length: SKELETON_ITEMS_COUNT }, (_, index) => ({
        id: `skeleton-${index}`,
      }));

  const renderMetricCard = (item: IMetricCardItem) => (
    <BybMetricCard metricType={item.metricType} score={item.score} target={item.target} compact={compact} />
  );

  return (
    <BybSection title={i18n("progress.metrics.title")}>
      {compact ? (
        <Grid container spacing={2} padding={2}>
          {metricItems.map(item => (
            <Grid item xs={6} key={item.id}>
              {renderMetricCard(item)}
            </Grid>
          ))}
        </Grid>
      ) : (
        <BybList sx={{ paddingX: 2, gap: 2, paddingBottom: 2 }}>
          {metricItems.map(item => (
            <BybMetricCard key={item.id} metricType={item.metricType} score={item.score} target={item.target} compact={compact} />
          ))}
        </BybList>
      )}
    </BybSection>
  );
};

export default BybMetricsList;
